import { SETTINGS_TYPES } from "@/constant";

export const getChangeParams = (changeSetting) => (value, changeValue, key) => {
    changeValue(!value);
    const params = {
        key: key,
        value: value ? '0' : '1',
        type: SETTINGS_TYPES.GENERAL,
    };
    changeSetting(params);
}

export const getChangeInput = (changeSetting) => (name, value, type = SETTINGS_TYPES.LOADING_PAGE) => {
    const params = {
        key: name,
        value: value,
        type: type,
    };
    changeSetting(params);
};

export const getSettingSelector = (name) => store => store.settings[name];

export const getCustomSettingSelector = (name) => store => store.settings.custom[name];